// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LCZJ_","badges":"styles_badges__1Lam-"};